import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/StaleServerActionRecovery.tsx");
